/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { GyroFundV1 } from "../GyroFundV1";

export class GyroFundV1__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<GyroFundV1> {
    return super.deploy(overrides || {}) as Promise<GyroFundV1>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): GyroFundV1 {
    return super.attach(address) as GyroFundV1;
  }
  connect(signer: Signer): GyroFundV1__factory {
    return super.connect(signer) as GyroFundV1__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GyroFundV1 {
    return new Contract(address, _abi, signerOrProvider) as GyroFundV1;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "redeemer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Redeem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bpoolAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_initialPoolWeight",
        type: "uint256",
      },
    ],
    name: "addPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "oracleAddress",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isStable",
        type: "bool",
      },
    ],
    name: "addToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_allUnderlyingPrices",
        type: "uint256[]",
      },
    ],
    name: "calculateAllPoolPrices",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "errorCode",
        type: "uint256",
      },
    ],
    name: "errorCodeToString",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllTokenPrices",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getReserveValues",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getUnderlyingTokenAddresses",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gyroPriceOracle",
    outputs: [
      {
        internalType: "contract GyroPriceOracle",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gyroRouter",
    outputs: [
      {
        internalType: "contract GyroRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_portfolioWeightEpsilon",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_priceOracleAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_routerAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_memoryParam",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initializeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_BPTokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_minGyroMinted",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToMint",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_BPTokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_minGyroMinted",
        type: "uint256",
      },
    ],
    name: "mintChecksPass",
    outputs: [
      {
        internalType: "uint256",
        name: "errorCode",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "estimatedMint",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_BPTokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_minGyroMinted",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_onBehalfOf",
        type: "address",
      },
    ],
    name: "mintFor",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToMint",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_BPTokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
    ],
    name: "mintTest",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolAddresses",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "poolProperties",
    outputs: [
      {
        internalType: "address",
        name: "poolAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "initialPoolWeight",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "initialPoolPrice",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "portfolioWeightEpsilon",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceOracle",
    outputs: [
      {
        internalType: "contract PriceOracle",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_BPTokensOut",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsOut",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_maxGyroRedeemed",
        type: "uint256",
      },
    ],
    name: "redeem",
    outputs: [
      {
        internalType: "uint256",
        name: "_gyroRedeemed",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_BPTokensOut",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsOut",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_maxGyroRedeemed",
        type: "uint256",
      },
    ],
    name: "redeemChecksPass",
    outputs: [
      {
        internalType: "uint256",
        name: "errorCode",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "estimatedAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
